import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { PortalContext } from "../../context/Provider";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import Sidebar from "../../components/Genericos/Sidebar/Sidebar";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import {
  informePDFReset,
  wsGetInformePDF,
  wsGetMisInformesSimplify,
} from "../../context/Actions/misInformes/misInformes";
import "./MisInformes.css";
import CardInforme from "../../components/Perfil/CardInforme/CardInforme";
import { infomesTituloTxt } from "./MisInformesTituloTxt";
import MultitabMobileMisInformes from "../../components/Turnos/MultitabMobileMisInformes/MultitabMobileMisInformes";
import Loading from "../../components/Genericos/Loading/Loading";
import { hideAyuda } from "../../context/Actions/ayuda/ayuda";
import { displayAyuda, displayAyudaMobile } from "../../../global/utils/ayuda";
import { dropdownFamiliares } from "../../components/Turnos/ListaFamiliaresDropdown/ListaFamiliaresDropdown";
import TurnoNoEncontrado from "../../components/Genericos/TurnoNoEcontrado/TurnoNoEncontrado";
import ToasterV2 from "../../../global/component/Genericos/Toaster/ToasterV2";
import { showModal } from "../../context/Actions/modal/modal";
import {
  LimpiarSelectE,
  LimpiarSelectGlobal,
  SelectUserGlobal,
} from "../../context/Actions/DropDownFamiliares/selectFamiliares";
import { GlobalContext } from "../../../global/context/Provider";
import { detectarNavegador } from "global/utils/detectarNavegador";
import { detectarIOS } from "global/utils/detectarIOS";
import camelize from "global/utils/camelize";
import { hideModal } from "global/context/action/modal/modal";
import { loginTokenReset } from "_+_Portal/context/Actions/token/loginToken";
import { showToaster } from "global/context/action/toaster/toaster";
import FloatingScroll from "_+_Portal/components/Genericos/FloatingScroll/FloatingScroll";
import { motion } from "framer-motion";
import {
  container,
  dots,
  pageContainerVariants,
} from "global/utils/cardAnimation";
import SelectDropdown from "_+_Portal/components/Genericos/SelectDropdown/SelectDropdown";
import HeaderTitle from "_+_Portal/components/Genericos/HeaderTitle/HeaderTitle";

const MisInformes = () => {
  const {
    misInformesState,
    misInformesDispatch,
    ayudaDispatch,
    listaFamiliaresState,
    modalDispatch,
    selectDropDownState,
    selectDropDownDispatch,
    enviarMailState,
    textosState,
    tokenState,
    tokenDispatch,
  } = useContext(PortalContext);
  const { authState, toasterState, toasterDispatch, configState } =
    useContext(GlobalContext);
  const history = useHistory();
  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const [flgBtnFiltro, setFlgBtnFiltro] = useState(true);
  const [dataInformes, setDataInformes] = useState(null);

  const widthWindow = window.innerWidth;
  const esMobile = widthWindow <= 768;

  const onClickBuscarTurnos = () => {
    if (configState.config.data.opcBuscadorTurnos && widthWindow > 1024) {
      history.push("/buscadorTurnos");
    } else {
      history.push("/consultamedica");
    }
  };

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  const onChangeMultitabInformes = (e) => {
    if (e !== "") {
      if (e.familiar && e.verResultados) {
        wsGetMisInformesSimplify(
          e.id,
          true,
          cargarInformes,
        )(misInformesDispatch);
        SelectUserGlobal({ id: e.id, paciente: e.paciente })(
          selectDropDownDispatch,
        );
        setFlgBtnFiltro(true);
      } else if (!e.familiar) {
        wsGetMisInformesSimplify(-1, true, cargarInformes)(misInformesDispatch);
        LimpiarSelectGlobal()(selectDropDownDispatch);
        setFlgBtnFiltro(true);
      } else {
        // Toaster que te dice que no estás autorizado
        showModal(
          "Perfil/ModalAlertGrupoFamiliar/ModalAlertGrupoFamiliar",
          {},
          "centro",
        )(modalDispatch);
        wsGetMisInformesSimplify(-1, true, cargarInformes)(misInformesDispatch);
        LimpiarSelectGlobal()(selectDropDownDispatch);
        setFlgBtnFiltro(true);
      }
    } else {
      LimpiarSelectE()(selectDropDownDispatch);
    }
  };

  const traerEstudios = () => {
    if (!selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      wsGetMisInformesSimplify(-1, false, cargarInformes)(misInformesDispatch);
      setFlgBtnFiltro(false);
    } else {
      wsGetMisInformesSimplify(
        selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
        false,
        cargarInformes,
      )(misInformesDispatch);
      setFlgBtnFiltro(false);
    }
  };

  const cargarInformes = (isCorrect, data) => {
    if (isCorrect) {
      setDataInformes(data);
    } else {
      // Manejar error parseado o legacy
      let mensajeError;
      let tipoToaster = "danger";

      if (data && typeof data === "object") {
        // Error parseado con nuestro handler
        if (
          data.type === "VALIDATION_ERROR" &&
          data.validationErrors?.length > 0
        ) {
          mensajeError = data.validationErrors[0].message;
          tipoToaster = "warning";
        } else {
          mensajeError =
            typeof data.detail === "string"
              ? data.detail
              : data.detail?.detail || data.title || "Error al cargar informes";
        }
      } else if (typeof data === "string") {
        // Error legacy como string directo
        mensajeError = data;
      } else {
        // Fallback final
        mensajeError = "Error al cargar informes";
      }

      showToaster(
        {
          texto: mensajeError,
          tipo: tipoToaster,
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };

  useEffect(() => {
    if (!selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      wsGetMisInformesSimplify(-1, true, cargarInformes)(misInformesDispatch);
    } else {
      wsGetMisInformesSimplify(
        selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
        true,
        cargarInformes,
      )(misInformesDispatch);
    }
    setTimeout(() => {
      hideAyuda()(ayudaDispatch);
      displayAyuda("hidden");
      displayAyudaMobile("hidden");
    }, 250);
    // buscarInformePorNotificacion();
  }, []);

  const buscarInformePorNotificacion = () => {
    if (tokenState.token.data) {
      const idTurno = tokenState.token.data.idturno;
      const listInformes = misInformesState.misInformes.data;

      const informeEncontrado = listInformes?.find(
        (informe) => informe.idturno === idTurno,
      );
      modalInformePdf(
        informeEncontrado?.tipo,
        informeEncontrado?.estudio,
        informeEncontrado?.codigo,
      );
    }
  };

  const modalInformePdf = (tipo, estudio, codigo) => {
    const sBrowser = detectarNavegador();
    const isIOS = detectarIOS();
    if (isIOS) {
      if (sBrowser !== "GoogleChrome") {
        informePdf(tipo, estudio, codigo);
      } else {
        modalAvisoNavegador();
      }
    } else {
      informePdf(tipo, estudio, codigo);
    }
  };

  const informePdf = (tipoAbv, estudio, codigo) => {
    wsGetInformePDF(tipoAbv, estudio, codigo, (isCorrect, data) =>
      verPDF(isCorrect, data, tipoAbv),
    )(misInformesDispatch);
  };

  const verPDF = (isCorrect, data, tipoAbv) => {
    if (isCorrect) {
      showModal(
        "Genericos/InformePDF/InformePDF",
        {
          titulo: `Informe: ${camelize(tipoAbv)}`,
          dissmiss: dissmiss,
          blob: data?.blob,
        },
        [],
        "centro",
        true,
      )(modalDispatch);
    } else {
      showToaster(
        {
          texto: "En este momento no se puede ver/descargar el informe",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
      hideModal()(modalDispatch);
    }
  };

  const modalAvisoNavegador = () => {
    showModal(
      "Genericos/DeteccionNavegador/DeteccionNavegador",
      {},
      [],
      "centro",
      false,
    )(modalDispatch);
  };

  const dissmiss = () => {
    hideModal()(modalDispatch);
    informePDFReset()(misInformesDispatch);
    loginTokenReset()(tokenDispatch);
  };

  return (
    <React.Fragment>
      {toasterState.toaster.show && <ToasterV2 />}
      <Loading
          dataLoading={
            misInformesState.misInformes.loading ||
            enviarMailState.enviarMail.loading
          }
          color="c-white"
          descripcion={
            misInformesState.misInformes.loading
              ? "Cargando Informe..."
              : "Enviando informe..."
          }
        />
      {/* HEADER BAR DE PORTAL  */}
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <HeaderTitle title={"Mis Informes"} />
      <MultitabMobileMisInformes
        valor={
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id
            : authState.auth.data.paciente.codigo
        }
        datos={dropdownFamiliares(
          listaFamiliaresState,
          authState,
          "VerResultados",
        )}
        onChange={onChangeMultitabInformes}
      />
      <div className="ptur-bodyContainer-MisInformes">
        <div className="ptur-mainSidebar">
          <Sidebar />
        </div>
        <motion.div
          variants={pageContainerVariants(esMobile)}
          initial="hidden"
          animate="visible"
          exit="exit"
          className={"mismed-body-MisInformes"}
        >
          <div className="ptur-MisInformes-tituloLabo rb24b">
            {infomesTituloTxt}
            <div className="ptur-MisInformes-dropdown-boton-container">
              <div className="ptur-MisInformes-dropdown">
                <SelectDropdown
                  data={dropdownFamiliares(
                    listaFamiliaresState,
                    authState,
                    "VerResultados",
                  )}
                  descripcion={"nombre"}
                  placeholder={"Seleccionar Familiar"}
                  onChangeInput={onChangeMultitabInformes}
                  selectedValue={
                    selectDropDownState.selectDropDown.selectGlobal
                      .pacienteElegido
                      ? selectDropDownState.selectDropDown.selectGlobal
                          .pacienteElegido.paciente
                      : authState.auth.data.paciente
                  }
                />
              </div>
            </div>
            <hr className="ptur-MisInformes-lineaSeparadora" />
          </div>
          {/*  {flgBtnFiltro ? (
            <div className="ptur-MisInformes-filtro bgc-latex10 c-white rb18l">
              <p>Se están mostrando los estudios de los últimos 3 meses</p>
              <button
                className="ptur-MisInformes-filtroBtn bgc-latex10 c-white rb18l"
                onClick={traerEstudios}
              >
                Ver Todos
              </button>
            </div>
          ) : (
            ""
          )} */}
          <div className="ptur-MisInformes-noEcontrado">
            <TurnoNoEncontrado
              state={misInformesState.misInformes?.data}
              loadingState={misInformesState.misInformes}
              texto={textosState.textos.data?.ofrecerBusqueda?.nombre}
              recomendacion={
                textosState.textos.data?.ofrecerBusqueda?.descripcion
              }
              txtBtn="Buscar un turno"
              onClickTurnos={onClickBuscarTurnos}
              array={"data"}
              showBtn={true}
            />
          </div>

          <motion.ul
            key={dataInformes?.length}
            className="ptur-MisInformes-cards"
            variants={container(0.1)}
            initial="hidden"
            animate="visible"
          >
            {Array.isArray(dataInformes) &&
              dataInformes
                .filter((item) => {
                  if (item.pendiente) {
                    const dias = (new Date() - new Date(item.fechaentrega)) / 86400000;
                    return dias <= 180;
                  }
                  return true;
                })
                .map((item, index) => (
                <motion.li
                  key={index}
                  className="itemCardInformes"
                  variants={dots()}
                >
                  <CardInforme item={item} />
                </motion.li>
              ))}
          </motion.ul>

          {misInformesState.misInformes.loading ? (
            ""
          ) : (
            // <div className="ptur-MisInformes-botonSubir">
            //   <BotonSubir body={"mismed-body-MisInformes"} />
            // </div>
            <FloatingScroll body={"mismed-body-MisInformes"} />
          )}
        </motion.div>
      </div>
    </React.Fragment>
  );
};
export default MisInformes;
